import { RequestStatus } from "./redux/apis/types";

export const isAdmin = process.env.REACT_APP_ROLE === "admin";
export const isClient = process.env.REACT_APP_ROLE === "client";
export const isSubContractor = process.env.REACT_APP_ROLE === "subc";

export type RequestType = {
  label: String;
};
export const REQUEST_TYPES = [
  {
    label: "Static",
  },
  {
    label: "Supervisor / Team Leader",
  },

  {
    label: "Event security",
  },
  {
    label: "Service Agent",
  },
  {
    label: "Reception",
  },
  {
    label: "Close protection",
  },
  {
    label: "Investigation",
  },
  {
    label: "Fire guard",
  },
  {
    label: "Traffic Control",
  },
  {
    label: "VIP Transportation",
  },
  {
    label: "Profiling, Observation",
  },
  {
    label: "Red teaming",
  },
  {
    label: "Security awareness",
  },
  {
    label: "Risk management",
  },
  {
    label: "K9 security",
  },
];

export const REQUEST_STATUS = [
  {
    label: "Pending (20)",
    value: RequestStatus.pending,
  },
  {
    label: "Confirmed (20)",
  },
  {
    label: "Canceled (20)",
  },
];
export const PLANNING_STATUS = [
  {
    label: "Confirmed (20)",
  },
  {
    label: "Canceled (20)",
  },
  {
    label: "Finished (20)",
  },
  {
    label: "Archived (20)",
  },
];

export const WEEKDAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
export const WEEKENDDAYS = ["Saturday", "Sunday"];
export const WORKDAYS = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
];

export const LICENCES = [
  "security guard licence",
  "close protection licence",
  "security events  licence",
  "investigation licence",
  "security guard k9 licence",
  "fire guard licence",
];
